$(document).ready(function () {
  const p = $("body").attr("p");
  const locationId = $("body").attr("event_id");
  if (p === "electronic_journal") {
    let order_by = "reg_date";
    let order_by_direction = "asc";
    let page = 1;

    $("select").select2({
      theme: "bootstrap4",
    });

    //datepicker initialization
    $("#start-date").datepicker({
      dateFormat: "dd-mm-yy",
    });
    $("#end-date").datepicker({
      dateFormat: "dd-mm-yy",
    });

    //submit on change
    $(document).on(
      "change",
      "#start-date, #end-date, #event-type",
      function () {
        const startDate = $("#start-date").val();
        const endDate = $("#end-date").val();
        const eventType = $("#event-type").val();
        getElectronicJournalList(
          locationId,
          eventType,
          startDate,
          endDate,
          1,
          order_by,
          order_by_direction
        );
      }
    );

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      page = parseInt($(this).attr("href").substring(6));
      let eventType = $("#event-type").val() ?? 0;
      let startDate = $("#start-date").val();
      let endDate = $("#end-date").val();

      getElectronicJournalList(
        locationId,
        eventType,
        startDate,
        endDate,
        page,
        order_by,
        order_by_direction
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();
      let eventType = $("#event-type").val() ?? 0;
      let startDate = $("#start-date").val();
      let endDate = $("#end-date").val();
      order_by = $(this).attr("data-order-by");
      order_by_direction = $(this).attr("data-order-by-direction");

      getElectronicJournalList(
        locationId,
        eventType,
        startDate,
        endDate,
        page,
        order_by,
        order_by_direction
      );
    });

    $(document).on("click", ".show-details-button", function () {
      const journalId = $(this).attr("data-electronic-journal-id");
      const parentTr = $(this).closest("tr");
      const detailContainer = parentTr.next(
        ".electronic-journal-detail-container"
      );
      const showIconDiv = $(this).closest("tr").find(".show-detail-icon");
      const hideIconDiv = $(this).closest("tr").find(".hide-detail-icon");

      if (detailContainer.length > 0) {
        detailContainer.remove();
        showIconDiv.toggleClass("d-none");
        hideIconDiv.toggleClass("d-none");
        return;
      }

      $.ajax({
        type: "POST",
        url: "/api/v1/private/electronic-journal/get-detail",
        data: {
          journal_id: journalId,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            parentTr.after(
              '<tr class="electronic-journal-detail-container"><td colspan="100%" style="border:none">' +
                data.html +
                "</td></tr>"
            );
            setTimeout(() => {
              showIconDiv.toggleClass("d-none");
              hideIconDiv.toggleClass("d-none");
            }, 200);
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    });

    function getElectronicJournalList(
      location_id = null,
      event_type,
      start_date,
      end_date,
      page = 1,
      order_by,
      order_by_direction
    ) {
      $.ajax({
        type: "POST",
        url: "/api/v1/private/electronic-journal/search",
        data: {
          location_id,
          event_type,
          start_date,
          end_date,
          page,
          order_by,
          order_by_direction,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $(".electronic-journal-view-content").empty();
            $(".electronic-journal-view-content").html(data.html);
          }
        })
        .fail(function (data) {
          if (data.error) {
            return alert(data.error);
          }
        });
    }
  }
});
